/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ when: NonNullable<unknown> }} Signed_In_WhenInputs */

const th_signed_in_when = /** @type {(inputs: Signed_In_WhenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`เข้าสู่ระบบ ${i?.when}`)
};

const en_signed_in_when = /** @type {(inputs: Signed_In_WhenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`signed in ${i?.when}`)
};

const ja_signed_in_when = /** @type {(inputs: Signed_In_WhenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ログイン ${i?.when}`)
};

const zh_signed_in_when = /** @type {(inputs: Signed_In_WhenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.when} 登录`)
};

const es_signed_in_when = /** @type {(inputs: Signed_In_WhenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`sesión iniciada ${i?.when}`)
};

const pt_signed_in_when = /** @type {(inputs: Signed_In_WhenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`conectado ${i?.when}`)
};

const id_signed_in_when = /** @type {(inputs: Signed_In_WhenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`masuk ${i?.when}`)
};

const fr_signed_in_when = /** @type {(inputs: Signed_In_WhenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`connecté ${i?.when}`)
};

const tl_signed_in_when = /** @type {(inputs: Signed_In_WhenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`nag-sign in ${i?.when}`)
};

const vi_signed_in_when = /** @type {(inputs: Signed_In_WhenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`đăng nhập ${i?.when}`)
};

const ko_signed_in_when = /** @type {(inputs: Signed_In_WhenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.when} 로그인`)
};

const de_signed_in_when = /** @type {(inputs: Signed_In_WhenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`angemeldet ${i?.when}`)
};

const ru_signed_in_when = /** @type {(inputs: Signed_In_WhenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`вход ${i?.when}`)
};

const tr_signed_in_when = /** @type {(inputs: Signed_In_WhenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.when} giriş yapıldı`)
};

const it_signed_in_when = /** @type {(inputs: Signed_In_WhenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`accesso ${i?.when}`)
};

const pl_signed_in_when = /** @type {(inputs: Signed_In_WhenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`zalogowano ${i?.when}`)
};

const uk_signed_in_when = /** @type {(inputs: Signed_In_WhenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`вхід ${i?.when}`)
};

const hi_signed_in_when = /** @type {(inputs: Signed_In_WhenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.when} साइन इन`)
};

const ar_signed_in_when = /** @type {(inputs: Signed_In_WhenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`سجّل الدخول ${i?.when}`)
};

const ms_signed_in_when = /** @type {(inputs: Signed_In_WhenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`log masuk ${i?.when}`)
};

const bn_signed_in_when = /** @type {(inputs: Signed_In_WhenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.when} সাইন ইন`)
};

const zh_tw2_signed_in_when = /** @type {(inputs: Signed_In_WhenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.when} 登入`)
};

const zh_hk2_signed_in_when = /** @type {(inputs: Signed_In_WhenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.when} 登入`)
};

const ur_signed_in_when = /** @type {(inputs: Signed_In_WhenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.when} سائن اِن`)
};

const fa_signed_in_when = /** @type {(inputs: Signed_In_WhenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ورود ${i?.when}`)
};

const sw_signed_in_when = /** @type {(inputs: Signed_In_WhenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`aliingia ${i?.when}`)
};

const nl_signed_in_when = /** @type {(inputs: Signed_In_WhenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ingelogd ${i?.when}`)
};

/**
* | output |
* | --- |
* | "signed in {when}" |
*
* @param {Signed_In_WhenInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const signed_in_when = /** @type {((inputs: Signed_In_WhenInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signed_In_WhenInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_signed_in_when(inputs)
	if (locale === "ja") return ja_signed_in_when(inputs)
	if (locale === "zh") return zh_signed_in_when(inputs)
	if (locale === "es") return es_signed_in_when(inputs)
	if (locale === "pt") return pt_signed_in_when(inputs)
	if (locale === "id") return id_signed_in_when(inputs)
	if (locale === "fr") return fr_signed_in_when(inputs)
	if (locale === "tl") return tl_signed_in_when(inputs)
	if (locale === "vi") return vi_signed_in_when(inputs)
	if (locale === "ko") return ko_signed_in_when(inputs)
	if (locale === "de") return de_signed_in_when(inputs)
	if (locale === "ru") return ru_signed_in_when(inputs)
	if (locale === "tr") return tr_signed_in_when(inputs)
	if (locale === "it") return it_signed_in_when(inputs)
	if (locale === "pl") return pl_signed_in_when(inputs)
	if (locale === "uk") return uk_signed_in_when(inputs)
	if (locale === "hi") return hi_signed_in_when(inputs)
	if (locale === "ar") return ar_signed_in_when(inputs)
	if (locale === "ms") return ms_signed_in_when(inputs)
	if (locale === "bn") return bn_signed_in_when(inputs)
	if (locale === "zh-TW") return zh_tw2_signed_in_when(inputs)
	if (locale === "zh-HK") return zh_hk2_signed_in_when(inputs)
	if (locale === "ur") return ur_signed_in_when(inputs)
	if (locale === "fa") return fa_signed_in_when(inputs)
	if (locale === "sw") return sw_signed_in_when(inputs)
	if (locale === "nl") return nl_signed_in_when(inputs)
	return en_signed_in_when(inputs)
});